<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="statusSlot" slot-scope="{ row }">
        <el-button type="link" @click="showDownProgress(row)" v-if="row.status == 0">{{new_product_status_map[row.status]}}</el-button>
        <span v-else>{{new_product_status_map[row.status]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
        <el-button
          v-if="row.status === 0 && row.channel === '从平台店铺下载'"
          type="link"
          @click="handleStopTask(row)"
          >终止任务</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";
import { stopTask } from '@api/prod/center';

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
    subCode: {
      type: [String, Number],
      default: '',
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "新增时间" } },
        { prop: "channel", attrs: { label: "途径" } },
        { prop: "source", attrs: { label: "数据来源" }},
        {prop: "operateContent", attrs: {label: "操作内容"}},
        { prop: "status", attrs: { label: "状态" }, slot: true },
        { prop: "staffName", attrs: { label: "操作人" } },
        { prop: "total", attrs: { label: "新增总数" } },
        { prop: "successTotal", attrs: { label: "新增成功数" } },
        { prop: "failureTotal", attrs: { label: "新增失败数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'subCodeMap']),
    new_product_status_map() {
      const { NEW_PRODUCT_STATUS_MAP }  = prod_center_dictionary;
      return NEW_PRODUCT_STATUS_MAP;
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
      let subCode = this.subCode;
      if (rowData.channel === '加入分销商品') {
        subCode = 21;
      }
      this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id,
            subCode,
          }
      })
    },
    showPublishSpeed(publishType) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType, resultVisible: true})
    },
    // 新增中，重新弹出进度条
    showDownProgress(rowData) {
      this.$emit('show-down-progress',rowData)
    },
    async handleStopTask(row) {
      this.$confirm('是否确认终止下载任务？', '提示', {
        type: 'warning',
      }).then(async () => {
        const res = await stopTask({ operationLogIds: row.id })
        if (res.result === 1) {
          this.$message.success('终止成功')
          this.$emit('refresh')
        }
      }).catch(() => {})
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
